<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10wrxJs/tc-custom/9781466816220.jpg?1725592370812" alt="This image is the cover for the book Merge, From Crosstown to Oblivion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Merge, From Crosstown to Oblivion
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>New York Times</i>–Bestselling Author: A minimum-wage worker-turned-multimillionaire turns his mind to cosmic mysteries upon meeting an alien being . . . </b><br/>  <br/> Raleigh Redman loved Nicci Charbon until she left him heartbroken. Then he hit the lotto for twenty-four million dollars, quit his minimum wage job, and set his sights on one goal: reading the entire collection of lectures in the Popular Educator Library, the only thing his father left behind after he died. As Raleigh is trudging through the eighth volume, he notices something in his apartment that at first seems ordinary but quickly reveals itself to be from a world very different from our own. This entity shows Raleigh joy beyond the comforts of twenty-four million dollars—and merges our world with those that live beyond . . .<br/>  <br/> “Mosley proves himself a master of both outsider and speculative fiction, rising above mere genre to ask the big questions.” ―<i>Shelf Awareness</i><br/>  <br/> “A writer whose work transcends category and qualifies as serious literature.” —<i>Time</i><br/>  <br/><i>At the Publisher’s request, this title is being sold without Digital Rights Management Software (DRM) applied.</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Walter Mosley
      </h2>
      
      <p class="authorDescription body article">Walter Mosley (b. 1952) is the author of the bestselling mystery series featuring Easy Rawlins, as well as numerous other works, from literary fiction and science fiction to a young adult novel and political monographs. His short fiction has been widely published, and his nonfiction has appeared in the <i>New York Times Magazine</i> and the <i>Nation</i>, among other publications. Mosley is the winner of numerous awards, including an O. Henry Award, the Anisfield-Wolf Book Award, a Grammy, and PEN America&rsquo;s Lifetime Achievement Award. He lives in New York City.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?706d4cfb